import React, { useEffect } from 'react';
import './BankInterestRates.css';
import MortgageTools from "../MortgageTools";
import Seo from "../components/Seo";


const BankInterestRates = () => {
  useEffect(() => {
    const cards = document.querySelectorAll('.bank-card');

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('flipped');
        }
      });
    }, { threshold: 0.3 });

    cards.forEach(card => observer.observe(card));
  }, []);

  return (
    <>


    
     <Seo
        title="Latest Bank Loan Interest Rates 2025 - Mortbuzz"
        description="Compare 2025 bank interest rates for home loans, business loans, car loans, LAP, and education loans. Find the best loan deals with Mortbuzz."
        keywords="bank interest rates 2025, home loan interest rates, business loan interest rates, car loan interest rates, LAP interest rates, education loan interest rates"
        canonical="https://www.mortbuzz.in/bank-interest-rates"
      />

    <div className="container py-4">
      <h1 className="header-title">ALL BANK INTEREST RATE</h1>

      <div className="row g-4 mt-3">
        {/* Bank cards here */}

        <div className="col-md-6 col-lg-4">
          <div className="bank-card">
            <div className="card-inner">
              <img src="/images/Bank Logos/sbibank.png" alt="SBI Logo" className="bank-logo" />
              <div className="bank-name">SBI Bank</div>
              <div className="rate-item"><span className="rate-type">Home Loan</span><span className="rate-value">7.65%</span></div>
              <div className="rate-item"><span className="rate-type">Loan Against Property</span><span className="rate-value">11.30% p.a.</span></div>
              <div className="rate-item"><span className="rate-type">Personal Loan</span><span className="rate-value">10.10%</span></div>
              <div className="rate-item"><span className="rate-type">Balance Transfer</span><span className="rate-value">7.65%</span></div>
              <div className="rate-item"><span className="rate-type">Business Loan</span><span className="rate-value">NONE</span></div>
              <div className="rate-item"><span className="rate-type">Car Loan</span><span className="rate-value">8.80%</span></div>
              <a href="apply-now" target="_blank" rel="noopener noreferrer">
                <button className="apply-btn">Apply Now</button>
              </a>
            </div>
          </div>
        </div>



         <div className="col-md-6 col-lg-4">
          <div className="bank-card">
            <div className="card-inner">
              <img src="/images/Bank Logos/bankofindia.png" alt="SBI Logo" className="bank-logo" />
              <div className="bank-name">Bank Of India</div>
              <div className="rate-item"><span className="rate-type">Home Loan</span><span className="rate-value">7.35%</span></div>
              <div className="rate-item"><span className="rate-type">Loan Against Property</span><span className="rate-value">9.10% p.a.</span></div>
              <div className="rate-item"><span className="rate-type">Personal Loan</span><span className="rate-value">11.10%</span></div>
              <div className="rate-item"><span className="rate-type">Balance Transfer</span><span className="rate-value">7.35%</span></div>
              <div className="rate-item"><span className="rate-type">Business Loan</span><span className="rate-value">none</span></div>
              <div className="rate-item"><span className="rate-type">Car Loan</span><span className="rate-value">7.85%</span></div>
              <a href="apply-now" target="_blank" rel="noopener noreferrer">
                <button className="apply-btn">Apply Now</button>
              </a>
            </div>
          </div>
        </div>



         <div className="col-md-6 col-lg-4">
          <div className="bank-card">
            <div className="card-inner">
              <img src="/images/Bank Logos/bankofmaharashtra.png" alt="SBI Logo" className="bank-logo" />
              <div className="bank-name">Bank Of Maharashtra</div>
              <div className="rate-item"><span className="rate-type">Home Loan</span><span className="rate-value">7.35%</span></div>
              <div className="rate-item"><span className="rate-type">Loan Against Property</span><span className="rate-value">9.95% p.a.</span></div>
              <div className="rate-item"><span className="rate-type">Personal Loan</span><span className="rate-value">9.00%</span></div>
              <div className="rate-item"><span className="rate-type">Balance Transfer</span><span className="rate-value">7.35%</span></div>
              <div className="rate-item"><span className="rate-type">Business Loan</span><span className="rate-value">none</span></div>
              <div className="rate-item"><span className="rate-type">Car Loan</span><span className="rate-value">7.70%</span></div>
              <a href="apply-now" target="_blank" rel="noopener noreferrer">
                <button className="apply-btn">Apply Now</button>
              </a>
            </div>
          </div>
        </div>


         <div className="col-md-6 col-lg-4">
          <div className="bank-card">
            <div className="card-inner">
              <img src="/images/Bank Logos/centralbankofindia.png" alt="SBI Logo" className="bank-logo" />
              <div className="bank-name">Central Bank Of India</div>
              <div className="rate-item"><span className="rate-type">Home Loan</span><span className="rate-value">7.35%</span></div>
              <div className="rate-item"><span className="rate-type">Loan Against Property</span><span className="rate-value">9.50% p.a.</span></div>
              <div className="rate-item"><span className="rate-type">Personal Loan</span><span className="rate-value">none</span></div>
              <div className="rate-item"><span className="rate-type">Balance Transfer</span><span className="rate-value">7.35%</span></div>
              <div className="rate-item"><span className="rate-type">Business Loan</span><span className="rate-value">none</span></div>
              <div className="rate-item"><span className="rate-type">Car Loan</span><span className="rate-value">7.90%</span></div>
              <a href="apply-now" target="_blank" rel="noopener noreferrer">
                <button className="apply-btn">Apply Now</button>
              </a>
            </div>
          </div>
        </div>



         <div className="col-md-6 col-lg-4">
          <div className="bank-card">
            <div className="card-inner">
              <img src="/images/Bank Logos/hdfcbank.png" alt="SBI Logo" className="bank-logo" />
              <div className="bank-name">HDFC Bank</div>
              <div className="rate-item"><span className="rate-type">Home Loan</span><span className="rate-value">7.90%</span></div>
              <div className="rate-item"><span className="rate-type">Loan Against Property</span><span className="rate-value">11.80% p.a.</span></div>
              <div className="rate-item"><span className="rate-type">Personal Loan</span><span className="rate-value">10.90%</span></div>
              <div className="rate-item"><span className="rate-type">Balance Transfer</span><span className="rate-value">7.90%</span></div>
              <div className="rate-item"><span className="rate-type">Business Loan</span><span className="rate-value">10.70%</span></div>
              <div className="rate-item"><span className="rate-type">Car Loan</span><span className="rate-value">7.90%</span></div>
              <a href="appy-now" target="_blank" rel="noopener noreferrer">
                <button className="apply-btn">Apply Now</button>
              </a>
            </div>
          </div>
        </div>



         <div className="col-md-6 col-lg-4">
          <div className="bank-card">
            <div className="card-inner">
              <img src="/images/Bank Logos/bankofbarodha.png" alt="SBI Logo" className="bank-logo" />
              <div className="bank-name">Bank Of Barodha</div>
              <div className="rate-item"><span className="rate-type">Home Loan</span><span className="rate-value">7.45%</span></div>
              <div className="rate-item"><span className="rate-type">Loan Against Property</span><span className="rate-value">9.70% p.a.</span></div>
              <div className="rate-item"><span className="rate-type">Personal Loan</span><span className="rate-value">10.30%</span></div>
              <div className="rate-item"><span className="rate-type">Balance Transfer</span><span className="rate-value">7.45%</span></div>
              <div className="rate-item"><span className="rate-type">Business Loan</span><span className="rate-value">none</span></div>
              <div className="rate-item"><span className="rate-type">Car Loan</span><span className="rate-value">8.40%</span></div>
              <a href="apply-now" target="_blank" rel="noopener noreferrer">
                <button className="apply-btn">Apply Now</button>
              </a>
            </div>
          </div>
        </div>




         <div className="col-md-6 col-lg-4">
          <div className="bank-card">
            <div className="card-inner">
              <img src="/images/Bank Logos/kotak_mahindra_bank.png" alt="SBI Logo" className="bank-logo" />
              <div className="bank-name">Kotak Mahindra bank</div>
              <div className="rate-item"><span className="rate-type">Home Loan</span><span className="rate-value">7.99%</span></div>
              <div className="rate-item"><span className="rate-type">Loan Against Property</span><span className="rate-value">9.50% p.a.</span></div>
              <div className="rate-item"><span className="rate-type">Personal Loan</span><span className="rate-value">10.99%</span></div>
              <div className="rate-item"><span className="rate-type">Balance Transfer</span><span className="rate-value">7.99%</span></div>
              <div className="rate-item"><span className="rate-type">Business Loan</span><span className="rate-value">none</span></div>
              <div className="rate-item"><span className="rate-type">Car Loan</span><span className="rate-value">none</span></div>
              <a href="apply-now" target="_blank" rel="noopener noreferrer">
                <button className="apply-btn">Apply Now</button>
              </a>
            </div>
          </div>
        </div>




         <div className="col-md-6 col-lg-4">
          <div className="bank-card">
            <div className="card-inner">
              <img src="/images/Bank Logos/axis_bank.png" alt="SBI Logo" className="bank-logo" />
              <div className="bank-name">Axis Bank</div>
              <div className="rate-item"><span className="rate-type">Home Loan</span><span className="rate-value">8.35%</span></div>
              <div className="rate-item"><span className="rate-type">Loan Against Property</span><span className="rate-value">9.70%</span></div>
              <div className="rate-item"><span className="rate-type">Personal Loan</span><span className="rate-value">10.30%</span></div>
              <div className="rate-item"><span className="rate-type">Balance Transfer</span><span className="rate-value">8.00%</span></div>
              <div className="rate-item"><span className="rate-type">Business Loan</span><span className="rate-value">13.50%</span></div>
              <div className="rate-item"><span className="rate-type">Car Loan</span><span className="rate-value">7.55%</span></div>
              <a href="apply-now" target="_blank" rel="noopener noreferrer">
                <button className="apply-btn">Apply Now</button>
              </a>
            </div>
          </div>
        </div>



         <div className="col-md-6 col-lg-4">
          <div className="bank-card">
            <div className="card-inner">
              <img src="/images/Bank Logos/bandhan_bank.png" alt="SBI Logo" className="bank-logo" />
              <div className="bank-name">Bandhan Bank</div>
              <div className="rate-item"><span className="rate-type">Home Loan</span><span className="rate-value">8.41%</span></div>
              <div className="rate-item"><span className="rate-type">Loan Against Property</span><span className="rate-value">11.89% p.a.</span></div>
              <div className="rate-item"><span className="rate-type">Personal Loan</span><span className="rate-value">9.47%</span></div>
              <div className="rate-item"><span className="rate-type">Balance Transfer</span><span className="rate-value">8.41%</span></div>
              <div className="rate-item"><span className="rate-type">Business Loan</span><span className="rate-value">13.50%</span></div>
              <div className="rate-item"><span className="rate-type">Car Loan</span><span className="rate-value">12.15%</span></div>
              <a href="apply-now" target="_blank" rel="noopener noreferrer">
                <button className="apply-btn">Apply Now</button>
              </a>
            </div>
          </div>
        </div>


         <div className="col-md-6 col-lg-4">
          <div className="bank-card">
            <div className="card-inner">
              <img src="/images/Bank Logos/indiaoverseasbank.png" alt="Indian Overseas Bank Logo" className="bank-logo" />
              <div className="bank-name">Indian Overseas Bank</div>
              <div className="rate-item"><span className="rate-type">Home Loan</span><span className="rate-value">7.35%</span></div>
              <div className="rate-item"><span className="rate-type">Loan Against Property</span><span className="rate-value">9.00% p.a.</span></div>
              <div className="rate-item"><span className="rate-type">Personal Loan</span><span className="rate-value">10.35%</span></div>
              <div className="rate-item"><span className="rate-type">Balance Transfer</span><span className="rate-value">7.45%</span></div>
              <div className="rate-item"><span className="rate-type">Business Loan</span><span className="rate-value">none</span></div>
              <div className="rate-item"><span className="rate-type">Car Loan</span><span className="rate-value">7.85%</span></div>
              <a href="apply-now" target="_blank" rel="noopener noreferrer">
                <button className="apply-btn">Apply Now</button>
              </a>
            </div>
          </div>
        </div>




         <div className="col-md-6 col-lg-4">
          <div className="bank-card">
            <div className="card-inner">
              <img src="/images/Bank Logos/indusind_bank.png" alt="indusind Logo" className="bank-logo" />
              <div className="bank-name">Indusind Bank</div>
              <div className="rate-item"><span className="rate-type">Home Loan</span><span className="rate-value">none</span></div>
              <div className="rate-item"><span className="rate-type">Loan Against Property</span><span className="rate-value">10.08%</span></div>
              <div className="rate-item"><span className="rate-type">Personal Loan</span><span className="rate-value">10.49%</span></div>
              <div className="rate-item"><span className="rate-type">Balance Transfer</span><span className="rate-value">none</span></div>
              <div className="rate-item"><span className="rate-type">Business Loan</span><span className="rate-value">15.99%</span></div>
              <div className="rate-item"><span className="rate-type">Car Loan</span><span className="rate-value">none</span></div>
              <a href="apply-now" target="_blank" rel="noopener noreferrer">
                <button className="apply-btn">Apply Now</button>
              </a>
            </div>
          </div>
        </div>




         <div className="col-md-6 col-lg-4">
          <div className="bank-card">
            <div className="card-inner">
              <img src="/images/Bank Logos/standard_chartered_bank.png" alt="SBI Logo" className="bank-logo" />
              <div className="bank-name">Standard Chartered Bank</div>
              <div className="rate-item"><span className="rate-type">Home Loan</span><span className="rate-value">8.95%</span></div>
              <div className="rate-item"><span className="rate-type">Loan Against Property</span><span className="rate-value">none</span></div>
              <div className="rate-item"><span className="rate-type">Personal Loan</span><span className="rate-value">11.99%</span></div>
              <div className="rate-item"><span className="rate-type">Balance Transfer</span><span className="rate-value">none</span></div>
              <div className="rate-item"><span className="rate-type">Business Loan</span><span className="rate-value">none</span></div>
              <div className="rate-item"><span className="rate-type">Car Loan</span><span className="rate-value">none</span></div>
              <a href="apply-now" target="_blank" rel="noopener noreferrer">
                <button className="apply-btn">Apply Now</button>
              </a>
            </div>
          </div>
        </div>

        {/* Repeat the above card component for each bank */}

      </div>
    </div>
     <MortgageTools />
    </>
  );
};

export default BankInterestRates;
